import { red } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "EvidenceComponent"
  helpImage1: {
    // margin: '20px !important',
    // padding: '20px !important',
    height: '40vh',
    [theme.breakpoints.only('xs')]: {
      height: '35vh',
    },
    [theme.breakpoints.only('sm')]: {
      height: '40vh',
    },
    [theme.breakpoints.only('md')]: {
      height: '45vh',
    },
    [theme.breakpoints.only('lg')]: {
      height: '50vh',
    },
    [theme.breakpoints.only('xl')]: {
      height: '55vh',
    },
  },
  title: {
    fontWeight: 'bold',
    fontSize: 20,
    width: '90% !important',
    textAlign: 'left !important',
    ['@media only screen and (max-width: 812px)']: {
      fontSize: 18,
    },
  },
  titleDoc: {
    fontWeight: 600,
    // width: '100%',
    paddingLeft: theme.spacing(1),
  },
  leftTitle: {
    fontWeight: 'bold',
    fontSize: '1em',
    width: '90% !important',
    textAlign: 'left !important',
    ['@media only screen and (max-width: 812px)']: {
      fontSize: 18,
    },
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
    // fontSize: 24,
  },

  documentCounter: { fontSize: '0.8em' },
  fullHeight: { height: '100% !important', padding: '0 !important', margin: '0 !important' },
  subTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 22,
  },
  formContainer: {
    height: '100% !important',
    position: 'relative !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    margin: 'auto',
    ['@media only screen and (min-width: 980px)']: {
      width: '60%',
    }

  },
  pdfCanvas: {
    margin: 'auto',
    display: 'table',
    maxWidth: '120px'
  },
  formRecordContainer: {
    height: '100% !important',
    width: '100%',
    position: 'relative !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    margin: 'auto'
  },
  topContainer: {
    display: 'block',
    position: 'absolute',
    top: '0',
    marginTop: '1.8em',
    padding: '1em',
    ['@media only screen and (min-width: 1280px)']: {
      padding: '3em 14em',
    }
  },
  middleContainer: {
    marginTop: '1.5em'
  },
  bottomContainer: {
    display: 'block',
    position: 'absolute',
    bottom: '0',
    marginTop: '1.8em',
    marginBottom: '1.8em',
    width: '95%',
    ['@media only screen and (min-width: 980px)']: {
      padding: '3em 0',
    }
  },
  leftContainer: {
    float: 'left',
    height: '100vh',
    width: '40%',
    backgroundColor: '#E3E3E3',
    padding: '1em'
  },
  rightContainer: {
    float: 'right',
    height: '100vh',
    width: '60%'
  },
  mainLandscapeContainer: { height: '100%' },
  mainOrientationContainer: { height: '100%' },
  pdfContainer: {
    height: '80%'
  },
  evidenceButtonContainer: {
    marginTop: '0.5em'
  },
  btnContainer: {
    display: 'flex !important',
    flexDirection: 'row !important',
    alignItems: 'center !important',
    justifyContent: 'flex-start !important',
    width: '100% !important',
  },
  helpImage: {
    // margin: theme.spacing(4),
    height: '40vh !important',
    ['@media only screen and (max-width: 812px)']: {
      height: '30vh !important'
    },
  },

  widthVideoFrame: {
    width: '100% !important',
    height: '100% !important'
  },
  rightContainerTop: {
    height: '85vh'
  },
  rightContainerBottom: {
    height: '15vh'
  },
  machupichu: {
    width: '100%'
  },
  containerImage: {
    display: 'grid !important',
    gridTemplateColumns: '100%',
    height: '53vh !important',
    marginTop: '3% !important',
    marginBottom: '3% !important',
    alignContent: 'center !important',
    overflow: 'none',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '100%',
      height: '55vh !important',
    },
  },
  acceptBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    marginTop: '2% !important',
    fontWeight: 'bold',
  },
  containerResult: {
    display: 'grid !important',
    gridTemplateColumns: '50% 50%',
    // gridTemplateColumns: '100%',
    height: '100vh !important',
    overflowY: 'auto',
    overflowX: 'none',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '40% 60%',
      // gridTemplateColumns: '100%',
      height: '100vh !important',
    },
  },
  leftColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    overflowY: 'none',
    justifyContent: 'center !important',
    textAlign: 'center',
    backgroundColor: '#E3E3E3',
    ['@media only screen and (max-width: 812px)']: {
      flexDirection: 'column !important',
      alignItems: 'center !important',
      justifyContent: 'flex-start !important',
      overflowY: 'none',
      height: '100vh !important',
    },
  },
  rightColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    // alignItems: 'center !important',
    alignItems: 'flex-start !important',
    // justifyContent: 'center !important',
    justifyContent: 'flex-start !important',
    overflowY: 'none',
    ['@media only screen and (max-width: 812px)']: {
      flexDirection: 'column !important',
      alignItems: 'flex-start !important',
      justifyContent: 'flex-start !important',
      overflowY: 'none',
    },
  },
  videoContainer: {
    height: '85% !important',
    width: '100% !important',
    ['@media only screen and (max-width: 812px)']: {
      height: '70% !important',
      width: '100% !important',
    },
  },
  videoDocsView: {
    backgroundColor: '#E3E3E3',
    height: '70% !important',
    width: '80% !important',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: '5%',
    marginBottom: '2%',
    ['@media only screen and (max-width: 812px)']: {
      height: '75% !important',
      width: '80% !important',
      minWidth: '85% !important',
      maxHeight: '80% !important',
      marginLeft: '5%',
      marginRight: '5%',
      marginTop: '0.5%',
      marginBottom: '0.5%',
      display: 'flex !important',
    },
  },
  marqueeCustom: {
    backgroundColor: '#F5F5F5 !important',
    padding: '6px',
    // overflowX: 'none !important',
    borderrounded: '12px !important',
    fontSize: '20px !important',
    height: '60px !important',
    overflowY: 'hidden !important',
  },
  warningContent: {
    display: 'flex',
    alignItems: 'center !important',
    overflowY: 'none',
    justifyContent: 'center !important',
    textAlign: 'center',
    height: '100vh !important',
  },
  warningAlert: {
    color: '#FFC200',
  },
  deviceOrientationContent: {
    width: '100% !important',
  },


  containerButtonResult: {
    display: 'grid !important',
    gridTemplateColumns: '50% 50%',
    height: '10vh !important',
    overflowY: 'auto',
    overflowX: 'none',
    marginTop: '2% !important',
    borderTop: `1px solid ${theme.palette.primary.color}`,
    ['@media only screen and (max-width: 812px)']: {
      height: '15vh !important',
    },
  },
  leftColumnButtonResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    overflowY: 'none',
    justifyContent: 'center !important',
    textAlign: 'center',
  },
  rightColumnButtonResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    overflowY: 'none',
    justifyContent: 'center !important',
    textAlign: 'center',
  },
  wizardContainer: {
    width: '100% !important',
    height: '70vh',
    overflowY: 'auto',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      height: '62vh',
    },
    marginBottom: theme.spacing(1),
    "& .swiper-pagination-container .swiper-pagination-dot__default": {
      width: '12px !important',
      height: '12px !important',
      "&.active": {
        backgroundColor: `${theme.palette.primary.main} !important`,
      }
    },

  },
  carouselSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  // textContent: {
  //   fontWeight: 'bold !important',
  //   width: '100%',
  //   ['@media only screen and (max-width: 812px)']: {
  //     width: '100%',
  //   }
  // },
  textContent1: {
    fontWeight: 'bold !important',
    width: '36%',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
    }
  },

  containerPage: {
    display: 'grid !important',
    gridTemplateColumns: '50% 50%',
    // overflowY: 'auto',
    // overflowX: 'none',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '40% 60%',
      // height: '100vh !important',
    },
  },
  leftColumnPage: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: ' flex-end; !important',
    // overflowY: 'none',
    justifyContent: 'center !important',
    // textAlign: 'center',
    backgroundColor: '#E3E3E3',
    ['@media only screen and (max-width: 812px)']: {
      flexDirection: 'column !important',
      alignItems: ' flex-end; !important',
      justifyContent: 'flex-start !important',
      // overflowY: 'none',
      // height: '100vh !important',
    },
  },
  rightColumnPage: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    minWidth: '200px',
    // overflowY: 'none',
    ['@media only screen and (max-width: 812px)']: {
      flexDirection: 'column !important',
      alignItems: 'flex-end !important',
      justifyContent: 'center !important',
      minWidth: '100px',
      // overflowY: 'none',
    },
  },
  CircleProgress: {
    color: `${theme.palette.primary.main} !important`,
    ['@media only screen and (max-width: 812px)']: {
      height: '25px !important',
      width: '25px !important',
      // overflowY: 'none',
    },
  },

  CenterStart: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    height: 'minmax(100vh, auto)',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0',  /* Remove scrollbar space */
      background: 'transparent',  /* Optional: just make scrollbar invisible */
    },
    overflowX: 'none',
  },
  centerContentStart: {
    width: '100% !important',
    height: '70vh',
    overflowY: 'auto',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    ['@media only screen and (max-width: 800px)']: {
      height: '70vh',
    },

    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // width: '60%',
    // position: 'relative',
    // overflow: 'none',
    // ['@media only screen and (max-width: 812px)']: {
    //   width: '90%',
    // },
    // margin: theme.spacing(2),
  },
  startNumeric: {
    fontSize: '7em',
    color: `${theme.palette.primary.main} !important`,
    margin: '0 !important',
    padding: '0 !important',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    ['@media only screen and (max-width: 812px)']: {
      fontSize: '5em',
    },
  },
  ImageStart: {
    // margin: theme.spacing(4),
    height: '40vh !important',
    ['@media only screen and (max-width: 812px)']: {
      height: '40vh !important',
    },
  },
  contentNumberGif: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100% !important'
    // overflow: 'none',
    // position: 'relative',
    // display: 'block',
    // textAlign: 'center',
  },
  centerContenMessage: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '85vh',
    position: 'relative',
    alignItems: 'center',
    alignContent: 'center',
    textAlign: 'center',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
      height: '73vh',
    }
  },
  textContent: {
    width: '90%',
    ['@media only screen and (max-width: 812px)']: {
      width: '95%',
    }
  },
  buttonContains: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    display: 'flex',
    width: '100% !important',
    height: '10vh !important',
    alignContent: 'center !important',
    alignItems: 'center !important',
    flexDirection: 'column',
    justifyContent: 'center',
    ['@media only screen and (max-width: 812px)']: {
      height: '12vh !important',
    },
  },
  buttonContains1: {
    // backgroundColor: `${theme.palette.secondary.main} !important`,
    display: 'flex',
    width: '100% !important',
    height: '10vh !important',
    alignContent: 'center !important',
    alignItems: 'center !important',
    flexDirection: 'column',
    justifyContent: 'center',
    ['@media only screen and (max-width: 812px)']: {
      height: '12vh !important',
    },
  },
  iconsStyle: {
    color: `${theme.palette.primary.main} !important`,
    fontSize: '3em'
  },
  buttonCont: {
    width: 'auto !important',
  },
  continueBtn: {
    width: '100%',
    alignSelf: 'center !important',
    marginTop: '20px'
  },
  buttonCont1: {
    width: '100% !important',
  },
  mapContainer: {
    // marginTop: '5%',
    height: '60vh !important',
    width: '100% !important',
    backgroundColor: '#8F918F',
    // marginBottom: '15%'
  },
  lottieImg: {
    width: '50% !important',
    height: '50% !important',
    color: `${theme.palette.primary.main} !important`,
  },
  containerImageLot: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    // height: '85vh',
    position: 'relative',
    alignItems: 'center',
    // ['@media only screen and (max-width: 812px)']: {
    //   width: '100%',
    //   height: '78vh',
    // }
  },
  lottieImgColor: {
    color: `${theme.palette.primary.main} !important`,
  },
  // cssAudio: {
  //   audio:: '-internal-media-controls-download-button {  display:none; }',
  //   audio:: '-webkit-media-controls-enclosure {  overflow:hidden;  }',

  //   audio:: '-webkit-media-controls-panel { width: calc(100% + 30px); /* Ajústalo a tu gusto */}
  // },

  visorContentPrinc: {
    border: '1px solid #A0A1A2',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
    height: '100%',
    width: '100%',
  },
  pdfContentCenter: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    textAlign: 'center',
  },
  imgHelpEvidence: {
    marginTop: '3.5em !important'
  },
  backgroundVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  wid100: {
    width: '100% !important'
  },
}))
